import React from 'react';

import style from './index.module.scss';

const Footer = () => (
  <div className={style.Footer}>
    Boteria - Powered by Code7
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://code7.com/privacidade-boteria/"
    >
      Política de Privacidade
    </a>
  </div>
);

export default Footer;
